import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Sales from './pages/Sales';
import Dispatch from './pages/Dispatch';
import Financial from './pages/Financial';
import StockPricing from './pages/StockPricing';
import WhatsAppBot from './pages/WhatsAppBot';
import Savings from './pages/Savings';
import Settings from './pages/Settings';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/stock-pricing" element={<StockPricing />} />
              <Route path="/whatsapp-bot" element={<WhatsAppBot />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/dispatch" element={<Dispatch />} />
              <Route path="/financial" element={<Financial />} />
              <Route path="/savings" element={<Savings />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </Layout>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'var(--color-surface)',
                color: 'var(--color-text-primary)',
                border: '1px solid var(--color-border)',
              },
            }}
          />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
